<script>
  import { slide } from 'svelte/transition';
  import LoginBackground from './LoginBackground.svelte';
  import { loginStore, activeView } from './loginStore';
  import { tv2Logo } from './Icons';
  import { trackEvent } from '../../analytics';
  import { channel } from '../Chat/chat-store';

  const onTV2PlayLoginClicked = async () => {
    if ($channel) {
      trackEvent({
        action: 'Chat - Join by Login',
        label: $channel.id,
        dimensions: {
          chatName: $channel.name,
          chatCategory: $channel.category,
        },
      });

      await window?.TV2?.login('Chat - Login', 'Chat login');
    }
  };

  const onAnonymousLoginClicked = () => {
    loginStore.setActiveView(activeView.ANONYMOUS_LOGIN);
    if ($channel) {
      trackEvent({
        action: 'Chat - Join as guest',
        label: $channel.id,
        dimensions: {
          chatName: $channel.name,
          chatCategory: $channel.category,
        },
      });
    }
  };
</script>

<div class="choose-login-container" data-category={$channel && $channel.category} in:slide>
  <LoginBackground
    icon={tv2Logo}
    backgroundColor={$channel &&
    ($channel.category === 'news' ||
      $channel.category === 'entertainment' ||
      $channel.category === 'sport')
      ? '#100118'
      : ''}
    on:close={() => loginStore.close()}
  />
  <div class="content">
    <h1>Si din mening!</h1>
    <div class="btns">
      {#if $channel && !$channel.political}
        <button class="sumo-login" on:click|stopPropagation={onTV2PlayLoginClicked}>
          Logg inn med din <span class="helper-nowrap">TV 2 Play</span> bruker
        </button>
        <p>eller</p>
      {/if}
      <button class="guest-login" on:click={onAnonymousLoginClicked}>Chat som gjest</button>
    </div>
  </div>
</div>

<style src="./chooseLogin.scss"></style>
